<div class="setting">
  <span class="setting-label-input">Prefix</span>
  <commands-ui-settings-input
    [value]="settings.prefix"
    (valueChange)="settings.prefix = $event"
  ></commands-ui-settings-input>
</div>
<div class="setting">
  <span class="setting-label-toggle">Tooltips</span>
  <mat-slide-toggle
    [checked]="settings.tooltipsEnabled"
    (change)="settings.tooltipsEnabled = $event.checked"
  ></mat-slide-toggle>
</div>
<div class="setting">
  <span class="setting-label-toggle">Cmd Strings</span>
  <mat-slide-toggle
    [checked]="settings.showCommandStrings"
    (change)="settings.showCommandStrings = $event.checked"
  ></mat-slide-toggle>
</div>
<div class="setting">
  <span class="setting-label-toggle">Alt Modules</span>
  <mat-slide-toggle
    [checked]="settings.altModules"
    (change)="settings.altModules = $event.checked"
  ></mat-slide-toggle>
</div>
